/**
 * Контейнер для отображения toast-уведомлений
 * Дата: 27.12.2025 - Создан для TODO-007 (замена alert на toast)
 * Связан с: frontend/src/store/toastStore.ts, frontend/src/components/ui/Toast.tsx
 */
import { Toast } from './Toast';
import { useToastStore } from '@/store/toastStore';

export function ToastContainer() {
  const toasts = useToastStore((state) => state.toasts);
  const removeToast = useToastStore((state) => state.removeToast);

  return (
    <div className="fixed top-4 right-4 z-50 flex flex-col gap-2 max-w-md">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          duration={toast.duration}
          onClose={() => removeToast(toast.id)}
          testId={`toast-${toast.id}`}
        />
      ))}
    </div>
  );
}

